exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-064d33c6] .el-card__body{height:100%}[data-v-064d33c6] .el-tabs{height:calc(100% - 70px)}[data-v-064d33c6] .el-tabs__content{height:calc(100% - 55px);overflow-y:auto}[data-v-064d33c6] .el-tab-pane{height:100%}[data-v-064d33c6] .el-form-item__label{text-align:right}[data-v-064d33c6] .el-upload{width:100%}", ""]);

// exports
